var getAddressDetails = function (_a) {
    var formData = _a.formData, dirtyFields = _a.dirtyFields;
    var mailingAddressPayload = {};
    var addressDirtyFields = dirtyFields.mailingAddress;
    var isStreetOneDirty = addressDirtyFields === null || addressDirtyFields === void 0 ? void 0 : addressDirtyFields.street1;
    var isStreetTwoDirty = addressDirtyFields === null || addressDirtyFields === void 0 ? void 0 : addressDirtyFields.street2;
    var isCityDirty = addressDirtyFields === null || addressDirtyFields === void 0 ? void 0 : addressDirtyFields.city;
    var isStateDirty = addressDirtyFields === null || addressDirtyFields === void 0 ? void 0 : addressDirtyFields.state;
    var isZipCodeDirty = addressDirtyFields === null || addressDirtyFields === void 0 ? void 0 : addressDirtyFields.zipCode;
    var mailingAddress = formData.mailingAddress;
    if (isStreetOneDirty ||
        isStreetTwoDirty ||
        isCityDirty ||
        isStateDirty ||
        isZipCodeDirty) {
        mailingAddressPayload["cipher.addressLine1"] = mailingAddress.street1;
        mailingAddressPayload["cipher.addressLine2"] = mailingAddress.street2;
        mailingAddressPayload["cipher.city"] = mailingAddress.city;
        mailingAddressPayload["cipher.state"] = mailingAddress.state;
        mailingAddressPayload["cipher.zipCode"] = mailingAddress.zipCode;
    }
    return mailingAddressPayload;
};
var getPhoneNumbers = function (_a) {
    var formData = _a.formData, dirtyFields = _a.dirtyFields;
    var phoneNumbers = [];
    Object.entries(formData.phoneNumbers).forEach(function (_a) {
        var _b, _c, _d;
        var contactType = _a[0], phoneNumber = _a[1];
        if (((_b = dirtyFields.phoneNumbers) === null || _b === void 0 ? void 0 : _b.home) && contactType === "home") {
            phoneNumbers.push({
                contactType: contactType.toUpperCase(),
                "cipher.contactNumber": phoneNumber.replace(/\D/g, ""),
            });
        }
        if (((_c = dirtyFields.phoneNumbers) === null || _c === void 0 ? void 0 : _c.business) && contactType === "business") {
            phoneNumbers.push({
                contactType: contactType.toUpperCase(),
                "cipher.contactNumber": phoneNumber.replace(/\D/g, ""),
            });
        }
        if (((_d = dirtyFields.phoneNumbers) === null || _d === void 0 ? void 0 : _d.mobile) && contactType === "mobile") {
            phoneNumbers.push({
                contactType: contactType.toUpperCase(),
                "cipher.contactNumber": phoneNumber.replace(/\D/g, ""),
            });
        }
    });
    return phoneNumbers;
};
var getProfilePayload = function (_a) {
    var formData = _a.formData, dirtyFields = _a.dirtyFields;
    var isDirtyAnnualNetIncome = dirtyFields.annualNetIncome, isDirtyEmailAddress = dirtyFields.emailAddress;
    var annualNetIncome = formData.annualNetIncome, emailAddress = formData.emailAddress;
    var payload = {};
    var netIncome = annualNetIncome === "" ? "0" : annualNetIncome;
    // Net Income
    if (isDirtyAnnualNetIncome) {
        payload["cipher.annualNetIncome"] = netIncome;
    }
    // Email
    if (isDirtyEmailAddress) {
        payload["cipher.email"] = emailAddress;
    }
    // Phone Numbers
    var phoneNumbers = getPhoneNumbers({ formData: formData, dirtyFields: dirtyFields });
    if (phoneNumbers.length) {
        payload.phone = phoneNumbers;
    }
    // Mailing Address
    var mailingAddress = getAddressDetails({ formData: formData, dirtyFields: dirtyFields });
    if (Object.keys(mailingAddress).length > 0) {
        payload.mailingAddress = mailingAddress;
    }
    // the form was not modified
    /*
     * If the form is saved with the same values,
     * the annual net income is sent again (even if it is the same value)
     * because the notification center needs to update the annual net income every 240 days.
     */
    if (Object.keys(payload).length === 0) {
        payload["cipher.annualNetIncome"] = netIncome;
    }
    return payload;
};
export default getProfilePayload;
